/*
 * Tabs content component
 *
 * @param {String} tab Active tab
 *
 * @return {Element}
 */
<template>
  <div class="tab-content promotion-tab-content">
    <div id="top" class="tab-pane" :class="activeTab('top')">
      <top :currentTab="tab" @checkData="checkData"></top>
    </div>
    <div id="promotion-request" class="tab-pane" :class="activeTab('promotion-request')">
      <promotion-request :currentTab="tab"></promotion-request>
    </div>
    <div id="promotion-info" class="tab-pane" :class="activeTab('promotion-info')">
      <promotion-info :currentTab="tab"></promotion-info>
    </div>
  </div>
</template>
<script>
import Top from './Top'
import PromotionRequest from './PromotionRequest'
import PromotionInfo from './PromotionInfo'

export default {
  components: {
    Top,
    PromotionRequest,
    PromotionInfo
  },
  props: {
    tab: {
      type: String,
      default: 'top'
    }
  },
  methods: {
    /*
     * Check data to disable/enable tab
     *
     * @param {Boolean} hasData User information exist or not
     *
     * @return void
     */
    checkData (hasData) {
      this.$emit('checkData', hasData)
    },
    /*
     * Check tab is active or not
     *
     * @param {String} tabName Tab's name
     *
     * @return {String}
     */
    activeTab (tabName) {
      return this.tab === tabName ? 'active' : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/promotion/TabContent.vue